import { Injectable } from '@angular/core';
import { ApiService } from '@app/api/api.service';
import { PointToApprove } from '@app/models';
import { Observable } from 'rxjs';

const prefix = '/order/point';

@Injectable({ providedIn: 'root' })
export class PointApi extends ApiService {
  public getListToApprove$(): Observable<PointToApprove[]> {
    return this.get<PointToApprove[]>(`${prefix}/approve/list`, true);
  }

  public setPointApprove$(orderId: number, pointId: number) {
    return this.post<{}, PointToApprove>(
      `${prefix}/approve/${orderId}/${pointId}`,
      {},
    );
  }
}
